import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MeasurementDTO } from '@core/apis/measurement/measurement.dto';
import { DownloadFileFormatEnum } from '@core/enums/measurement.enum';
import { CsvEcgMeasurementService } from '@core/services/csv-ecg-measurement.service';
import { CsvOsMeasurementService } from '@core/services/csv-os-measurement.service';
import { ReusableDownloadMeasurementsService } from '@core/services/reusable-download-measurement.service';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Loading } from '@oranta-mis/ui-library';
declare let bootstrap: any;

@Component({
  selector: 'app-confirm-download-measurement-dialog',
  imports: [TranslocoModule, CommonModule, FormsModule, Loading],
  templateUrl: './confirm-download-measurement-dialog.component.html',
  styleUrls: ['./confirm-download-measurement-dialog.component.scss'],
})
@UntilDestroy()
export class ConfirmDownloadMeasurementDialogComponent extends ReusableDownloadMeasurementsService {
  public format!: DownloadFileFormatEnum;

  @Input() public selectedItems!: MeasurementDTO[];
  @Output() public success: EventEmitter<void> = new EventEmitter();
  private modalInstance!: any;
  protected readonly DownloadFileFormatEnum = DownloadFileFormatEnum;

  constructor(
    protected override csvOsMeasurementService: CsvOsMeasurementService,
    protected override csvEcgMeasurementService: CsvEcgMeasurementService,
  ) {
    super(csvOsMeasurementService, csvEcgMeasurementService);
  }

  public openModal() {
    const modalElement = document.getElementById('basketModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      this.modalInstance.show();
    }
  }

  public closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }

  public download(): void {
    const onComplete = () => {
      this.isLoading = false;
      this.success.emit();
      this.closeModal();
    };

    this.isLoading = true;
    if (DownloadFileFormatEnum.csv == this.format) {
      this.generateMeasurementCsvFiles(this.selectedItems, onComplete);
    } else if (DownloadFileFormatEnum.json == this.format) {
      this.downloadMeasurementsJsonFiles(this.selectedItems, onComplete);
    }
  }
}
